import React from "react";
import PdfFromGrid, { PdfFromGridProps } from "../../components/PdfFromGrid";
import { useLocation, useNavigate } from "react-router-dom";
import { usePDF } from "@react-pdf/renderer";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import LoadingPage from "../LoadingPage";

export default function ViewPDFPage() {
  const location = useLocation().state as PdfFromGridProps;
  let state = useLocation().state;

  const navigate = useNavigate();

  const [instance, update] = usePDF({
    document: <PdfFromGrid title={location.title} data={location.data} />,
  });
  if (!location?.data || !location?.title) {
    navigate("/");
  }
  if (instance.error) {
    navigate(-1);
  }
  if (instance?.url) {
    window.location.assign(`${instance.url}`);
  }
  return <LoadingPage />;
}
